/**
 * Chamadas da aba ChatBot → Configurações e os valores de exemplo da prévia.
 * A configuração da CLEO vive em GET/PUT /api/chatbot/cleo-config; as etapas
 * do pedido em /api/order-status-templates; pausa e entretenimento em
 * /api/chatbot/bot-settings; a fila de atendimento em /api/chatbot/waiting-queue;
 * os modelos de aviso do WhatsApp oficial em /api/whatsapp/oficial/modelos.
 */
const API = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });
const get = (p) => fetch(`${API}${p}`, { headers: auth(), cache: "no-store" }).then((r) => r.json());
const send = (m, p, b) => fetch(`${API}${p}`, { method: m, headers: auth(), body: JSON.stringify(b) }).then((r) => r.json());

export const cleoApi = {
  config: () => get("/api/chatbot/cleo-config"),
  salvarConfig: (config) => send("PUT", "/api/chatbot/cleo-config", { config }),
  etapas: () => get("/api/order-status-templates"),
  salvarEtapa: (tipo, status, body) => send("PUT", `/api/order-status-templates/${tipo}/${status}`, body),
  botSettings: () => get("/api/chatbot/bot-settings"),
  salvarBotSettings: (body) => send("PUT", "/api/chatbot/bot-settings", body),
  fila: () => get("/api/chatbot/waiting-queue"),
  ignorar: (phone) => fetch(`${API}/api/chatbot/waiting-queue/${phone}`, { method: "DELETE", headers: auth() }),
  ignorarTodos: () => fetch(`${API}/api/chatbot/waiting-queue/clear`, { method: "POST", headers: auth() }),
  somFila: `${API}/api/sounds/cliente-esperando`,
  modelosOficiais: () => get("/api/whatsapp/oficial/modelos"),
  conferirModelos: () => send("POST", "/api/whatsapp/oficial/modelos/conferir", {}),
};

/** Valores de exemplo das variáveis, só pra prévia no celular. */
export const EXEMPLOS = {
  codigo: "12345",
  endereco: "Rua das Flores, 123",
  motivo: "Cliente solicitou cancelamento",
  nome: "Maria",
  nome_entregador: "Carlos",
  link: "https://entregaai.usenucleo.com.br/rastreio/abc123",
  tipo_pagamento: "PIX",
  valor: "59,90",
  minutos: "30",
  mudancas: "💰 Total: R$ 59,90 → R$ 64,90",
  etapa: "Em produção",
  horario: "Sáb 04/10 · 19:00–19:30",
  TEMPO: "15",
};

/** Troca {variavel} e [TEMPO] pelos exemplos; linha só de variável vazia some. */
export function preencherExemplo(texto, extras = {}) {
  const valores = { ...EXEMPLOS, ...extras };
  return (texto || "")
    .split("\n")
    .map((linha) => linha.replace(/\{(\w+)\}/g, (_, v) => valores[v] ?? `{${v}}`).replace(/\[TEMPO\]/gi, valores.TEMPO))
    .join("\n");
}

/** Insere `trecho` na posição do cursor de um textarea (ou no fim). */
export function inserirNoCursor(el, texto, trecho) {
  const ini = el ? el.selectionStart : texto.length;
  const fim = el ? el.selectionEnd : texto.length;
  const antes = texto.slice(0, ini), depois = texto.slice(fim);
  const pre = antes && !/\s$/.test(antes) ? " " : "";
  const pos = depois && /^[\p{L}\p{N}]/u.test(depois) ? " " : "";
  return { texto: `${antes}${pre}${trecho}${pos}${depois}`, cursor: (antes + pre + trecho + pos).length };
}
